<mat-dialog-actions class="bar-dialog">
    <span class="bar-text-dialog">Selecciona el tipo de Envio que deseas</span>
    <button class="bar-exit-dialog" mat-icon-button mat-dialog-close align="end"><mat-icon>close</mat-icon></button>
</mat-dialog-actions>
<mat-dialog-content class="content-vertical-detail">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" style="margin: 0px; padding-left: 0px; padding-right: 0px; margin-top: 6rem;" *ngIf="dataAddresses.length > 0">
        <div class="row col-xl-12 col-lg-12 col-md-12 col-sm-12" style="margin-top: 2rem; padding: 0px 3rem 0px 3rem !important;" *ngFor="let address of dataAddresses">
            <div class="col-xl-10 col-lg-10 col-md-8 col-sm-12">
                <p class="title-address">DIRECCION</p>
                <p class="text-address">{{address.ext_number}} {{address.street}}</p>
                <p class="text-address">{{address.locality.name}} C.P.: {{address.zip_code}}</p>
                <p class="text-address">{{address.municipality.name}}, {{address.state.name}}</p>
                <p class="title-person">DATOS DE LA PERSONA QUE RECIBE</p>
                <p class="text-person">{{address.receiving_name}}</p>
                <p class="text-person">Cel: {{address.phone}}</p>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-4 col-sm-12"
                style="text-align: right; display: flex; flex-direction: column;">
                <button class="red-button"
                        mat-raised-button
                        style="margin-top: auto;"
                        (click)="onSelectAddress(address);">
                    Seleccionar
                </button>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <hr style="margin-top: 2rem; margin-bottom: 2rem;">
            </div>
        </div>
    </div>
</mat-dialog-content>